import React, { useRef, useState } from "react";
import L from "leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { Marker, Popup, Tooltip } from "react-leaflet";

import "react-leaflet-markercluster/dist/styles.min.css";
import "leaflet/dist/leaflet.css";

import "../styles/index.css";
import "../styles/fleetmap.css";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { LABELS } from "common/lables";
import { API_CONFIG } from "common/config";

const CustomerPlotting = (props: any) => {
  const {
    createClusterCustomIcon,
    showCustomerCluster,
    setShowCustomerCluster,
    customers,
    getMapMarker,
  } = props;

  const [customersDeatil, setCustomersDeatil] = useState<any>([]);

  /**
   * For showing customers details on popover, called when marker is clicked
   */
  const getCustomerDetailsOnMAp = async (customerId) => {
    try {
      const args = {
        customerId,
      };
      const res: any = await CUSTOMER_APIs.getCustomerDetailsOnMap(args);
      if (res.status === 200) {
        const customerDetails = res.response;
        console.log("data", customerDetails);
        setCustomersDeatil(customerDetails);
      }
    } catch (error) {
      console.log("getDistricts: ", error);
    }
  };
  console.log("customer", customersDeatil, showCustomerCluster);
  return (
    <>
      {showCustomerCluster ? (
        <MarkerClusterGroup
          iconCreateFunction={createClusterCustomIcon}
          showCoverageOnHover={true}
        >
          {customers &&
            customers.map((customer, i) => {
              return (
                <Marker
                  position={{
                    lat: customer.lat,
                    lng: customer.lng,
                  }}
                  icon={getMapMarker(customer.orgId)}
                  key={"mapMarker-" + i}
                  className="mapMarker"
                  onclick={() => getCustomerDetailsOnMAp(customer.id)}
                >
                  (
                  <Popup>
                    <div
                      style={{
                        width: "max-content",
                        margin: "0.5rem",
                      }}
                    >
                      <table>
                        <tbody>
                          <tr>
                            <td colSpan={3}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <h2 style={{ margin: "0.3rem 0" }}>
                                  {customer.name}
                                </h2>
                                <div
                                  className="customerDetails"
                                  style={
                                    customer.isactive
                                      ? {
                                          backgroundColor: "green",
                                        }
                                      : { backgroundColor: "red" }
                                  }
                                ></div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3
                                style={{
                                  margin: "0.1rem 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {LABELS.INCHARGE}
                              </h3>
                            </td>
                            <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                            <td>
                              <h3 style={{ margin: "0.1rem 0" }}>
                                {/* {customersDeatil[0].incharge} */}
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3
                                style={{
                                  margin: "0.1rem 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {LABELS.MOBILE_NO}
                              </h3>
                            </td>
                            <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                            <td>
                              <h3 style={{ margin: "0.1rem 0" }}>
                                {/* {customersDeatil[0].mobileno} */}
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3
                                style={{
                                  margin: "0.1rem 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {LABELS.UPDATED_BY}
                              </h3>
                            </td>
                            <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                            <td>
                              <h3 style={{ margin: "0.1rem 0" }}>
                                {/* {customersDeatil[0].updatedBy} */}
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3
                                style={{
                                  margin: "0.1rem 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {LABELS.LOCATION}
                              </h3>
                            </td>
                            <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                            <td>
                              <h3 style={{ margin: "0.1rem 0" }}>
                                {/* {customer.lat + " ," + customer.lng} */}
                              </h3>
                            </td>
                          </tr>
                          {/* <tr>
                            <td colSpan={3}>
                              <img
                                // src={`${API_CONFIG.STATIC_URL}${customersDeatil[0].path}`}
                                src="https://gopaluatapi.neyaai.com/static/customers/2023/6/230609Jun061686286959186944_16.jpeg"
                                alt="Another Image Description"
                                width="200"
                                height="150"
                              />
                            </td>
                          </tr> */}
                        </tbody>
                      </table>
                    </div>
                  </Popup>
                  )
                  <Tooltip
                    direction="right"
                    offset={[10, -2]}
                    permanent
                    className={"makerLabel"}
                  >
                    <span>{customer.name}</span>
                  </Tooltip>
                </Marker>
              );
            })}
        </MarkerClusterGroup>
      ) : (
        <>
          {customers &&
            customers.map((customer, i) => {
              return (
                <Marker
                  position={{
                    lat: customer.lat,
                    lng: customer.lng,
                  }}
                  icon={getMapMarker(customer.orgId)}
                  key={"mapMarker-" + i}
                  className="mapMarker"
                  onclick={() => getCustomerDetailsOnMAp(customer.id)}
                >
                  (
                  <Popup>
                    <div
                      style={{
                        width: "max-content",
                        margin: "0.5rem",
                      }}
                    >
                      <table>
                        <tbody>
                          <tr>
                            <td colSpan={3}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <h2 style={{ margin: "0.3rem 0" }}>
                                  {customer.name}
                                </h2>
                                <div
                                  className="customerDetails"
                                  style={
                                    customer.isactive
                                      ? {
                                          backgroundColor: "green",
                                        }
                                      : { backgroundColor: "red" }
                                  }
                                ></div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3
                                style={{
                                  margin: "0.1rem 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {LABELS.INCHARGE}
                              </h3>
                            </td>
                            <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                            <td>
                              <h3 style={{ margin: "0.1rem 0" }}>
                                {/* {customersDeatil[0].incharge} */}
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3
                                style={{
                                  margin: "0.1rem 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {LABELS.MOBILE_NO}
                              </h3>
                            </td>
                            <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                            <td>
                              <h3 style={{ margin: "0.1rem 0" }}>
                                {/* {customersDeatil[0].mobileno} */}
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3
                                style={{
                                  margin: "0.1rem 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {LABELS.UPDATED_BY}
                              </h3>
                            </td>
                            <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                            <td>
                              <h3 style={{ margin: "0.1rem 0" }}>
                                {/* {customersDeatil[0].updatedBy} */}
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3
                                style={{
                                  margin: "0.1rem 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {LABELS.LOCATION}
                              </h3>
                            </td>
                            <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                            <td>
                              <h3 style={{ margin: "0.1rem 0" }}>
                                {/* {customer.lat + " ," + customer.lng} */}
                              </h3>
                            </td>
                          </tr>
                          {/* <tr>
                            <td colSpan={3}>
                              <img
                                // src={`${API_CONFIG.STATIC_URL}${customersDeatil[0].path}`}
                                src="https://gopaluatapi.neyaai.com/static/customers/2023/6/230609Jun061686286959186944_16.jpeg"
                                alt="Another Image Description"
                                width="200"
                                height="150"
                              />
                            </td>
                          </tr> */}
                        </tbody>
                      </table>
                    </div>
                  </Popup>
                  )
                  <Tooltip
                    direction="right"
                    offset={[10, -2]}
                    permanent
                    className={"makerLabel"}
                  >
                    <span>{customer.name}</span>
                  </Tooltip>
                </Marker>
              );
            })}
        </>
      )}
    </>
  );
};

export default CustomerPlotting;
